import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize11, fontWeightNormal, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { AppearanceInvert } from "@churchofjesuschrist/eden-appearance";
import { jsx as _jsx } from "react/jsx-runtime";
const Container6 = styled.div.withConfig({
  componentId: "sc-ht51d3-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightNormal, lineHeight, fontSize11, shared, fontWeightBold);
const Text6 = _ref => {
  let {
    children,
    renderAs = "div",
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(AppearanceInvert, {
    inverted: props.inverted,
    children: /*#__PURE__*/_jsx(Container6, {
      as: renderAs,
      ...props,
      children: children
    })
  });
};
Text6.displayName = "Text6";
Text6.propTypes = {
  /** Content */
  children: PropTypes.node.isRequired,
  /** What html tag or custom react element to render the text as */
  renderAs: PropTypes.elementType,
  /** Whether to apply styles that help the text stand out on a dark background. (deprecated) */
  inverted: PropTypes.bool
};
export default Text6;